import { createFileRoute, redirect } from '@tanstack/react-router';
import { tokenStore } from '@/auth/token';
import { APP_ROUTES } from '@/const/routes';

export const Route = createFileRoute('/')({
  beforeLoad: ({ location }) => {
    if (!tokenStore.get()) {
      throw redirect({ to: APP_ROUTES.login, search: location.search as Record<string, string> });
    }
    throw redirect({ to: APP_ROUTES.app.index });
  },
});
